<template>
  <div class="details-page">
    <div class="details-page__header">
      <div class="details-page__header-content">
      <button class="button" @click="router.push('/')">
        <span class="icon icon--arrow-left"></span>
        Tillbaka
      </button>
      <h1 class="heading">{{ ship?.name }}</h1>
      </div>
    </div>
    <div class="details-page__content">
      <button @click="exportToExcel()" class="button">
        Ladda ned
        <span class="icon icon--download"></span>
      </button>
      <ShipDetails :ship="ship" />
      <section class="details-page__comments" v-if="ship?.comments">
        <h2 class="details-page__section-title">Kommentar</h2>
        <p v-for="(comment, i) in ship?.comments" :key="`comment-${i}`">{{ comment }}</p>
      </section>

      <section class="details-page__misc">
        <div v-if="ship?.webReferences">
          <h2 class="details-page__section-title">Länkar</h2>
          <ul>
            <li v-for="(webReference, i) in ship?.webReferences" :key="`webReference-${i}`"
              v-html="autoLink(webReference)" />
          </ul>
        </div>
        <div v-if="ship?.references">
          <h2 class="details-page__section-title">Referens</h2>
          <ul>
            <li v-for="(reference, i) in ship?.references" :key="`reference-${i}`" v-html="autoLink(reference)" />
          </ul>
        </div>
      </section>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ComputedRef } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from "@/stores/store";
import { useUtil } from "@/services/util-service";
import { ISearchResultItem } from 'interfaces/search/ISearchResultItem';
import ShipDetails from './ShipDetails.vue';

const route = useRoute();
const router = useRouter();
const store = useStore();

const shipId = route.params.shipId;
const ship: ComputedRef<ISearchResultItem> = computed(() => store.originalSearchResult?.results.find((ship: any) => ship.uuid === shipId));

const exportToExcel = () => {
  let array: ISearchResultItem[] = [ship.value];
  useUtil().exportToExcel(array);
}

const autoLink = (text: string): string => {
  const urlRegex = /((https?:\/\/)?(www\.)?[^\s]+\.[^\s]{2,})([.,;!?)]*)/gi
  return text.replace(urlRegex, (_, url, _protocol, _www, trailing) => {
    const fullUrl = url.startsWith('http') ? url : `https://${url}`
    return `<a href="${fullUrl}" target="_blank" rel="noopener">${url}</a>${trailing}`
  })
}

</script>
